import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Accordion/accordion';
import { AccordionContext } from './AccordionContext';
export var AccordionContent = function AccordionContent(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$id = _a.id,
      id = _a$id === void 0 ? '' : _a$id,
      _a$isHidden = _a.isHidden,
      isHidden = _a$isHidden === void 0 ? false : _a$isHidden,
      _a$isFixed = _a.isFixed,
      isFixed = _a$isFixed === void 0 ? false : _a$isFixed,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? '' : _a$ariaLabel,
      component = _a.component,
      props = __rest(_a, ["className", "children", "id", "isHidden", "isFixed", 'aria-label', "component"]);

  return React.createElement(AccordionContext.Consumer, null, function (_ref) {
    var ContentContainer = _ref.ContentContainer;
    var Container = component || ContentContainer;
    return React.createElement(Container, Object.assign({
      id: id,
      className: css(styles.accordionExpandedContent, isFixed && styles.modifiers.fixed, !isHidden && styles.modifiers.expanded, className),
      hidden: isHidden,
      "aria-label": ariaLabel
    }, props), React.createElement("div", {
      className: css(styles.accordionExpandedContentBody)
    }, children));
  });
};